import React, { useContext } from "react"
import LanguageContext from "../contexts/language"
import messagesByLang from "../resources/lang/messages"
import { getLangFromPageContext, getUrlPrefix } from "../utils/lang"

/**
 * Provides LanguageContext before page templates render.
 * Templates that call useContext(LanguageContext) above <Layout> otherwise
 * always see the default { lang: "es" }, which breaks EN titles and <html lang>.
 *
 * Inherit theme / accesibilitySize from the context default (localStorage);
 * only override language fields this provider owns.
 */
const LanguageProvider = ({ pageContext, children }) => {
  const inherited = useContext(LanguageContext)
  const lang = getLangFromPageContext(pageContext)
  const messages = messagesByLang[lang] || {}
  const urlPrefix = getUrlPrefix(lang)

  return (
    <LanguageContext.Provider
      value={{ ...inherited, lang, messages, urlPrefix }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageProvider
